import { createSlice } from "@reduxjs/toolkit";
import { DestinationDTO } from "../../shared/dtos/destinationsDTO";
import MapDTO from "../../shared/dtos/mapDTO";
import providerDTO from "../../shared/dtos/providerDTO";
import { OriginDTO } from "../../shared/dtos/originDTO";
import { GoogleMapsCountryDTO } from "../../shared/dtos/googleMapsCountryDTO";
import { COUNTRIES } from "../../utils/constants/countries";
import { checkPointsDTO } from "../../shared/dtos/checkPointsDTO";

export interface MapState {
  list: Array<providerDTO>;
  show: boolean;
  destinations: MapDTO | null;
  distance: number;
  duration: number;
  country: GoogleMapsCountryDTO;
  countryName: string;
}

const initialState: MapState = {
  list: [],
  show: false,
  destinations: null,
  distance: 0,
  duration: 0,
  country: COUNTRIES[0],
  countryName: "",
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    set: (state, action) => {
      state.list = action.payload;
    },
    reset: (state) => {
      state.list = [];
    },
    showProviders: (state, action) => {
      state.show = action.payload;
    },
    setDestinations: (state, action) => {
      state.destinations = action.payload;
    },
    resetTrip: (state) => {
      state.destinations = null;
    },
    setDistance: (state, action) => {
      state.distance = action.payload.distance;
      state.duration = action.payload.duration;
    },
    setGoogleMapsCountry: (state, action) => {
      state.country = action.payload;
    },
    setCountryName: (state, action) => {
      state.countryName = action.payload;
    },
  },
});

export const {
  set,
  reset,
  showProviders,
  setDestinations,
  resetTrip,
  setDistance,
  setGoogleMapsCountry,
  setCountryName,
} = mapSlice.actions;
export const selectDrivers = (state: any) => state.map.list;

export const setDestination =
  (value: DestinationDTO | undefined) => (dispatch: any, getState: any) => {
    dispatch(
      setDestinations({ ...getState().map.destinations, dropOff: value }),
    );
  };

export const setWaypoints =
  (value: checkPointsDTO[] | undefined) => (dispatch: any, getState: any) => {
    dispatch(
      setDestinations({
        ...getState().map.destinations,
        wayPoints: [...(value ?? [])],
      }),
    );
  };

export const setOrigin =
  (value: OriginDTO | undefined, countryName?: string) =>
  (dispatch: any, getState: any) => {
    dispatch(
      setDestinations({ ...getState().map.destinations, pickUp: value }),
    );
    if (countryName) dispatch(setCountryName(countryName));
  };

export const setCountry =
  (value: GoogleMapsCountryDTO) => (dispatch: any, getState: any) => {
    dispatch(setGoogleMapsCountry(value));
  };

export default mapSlice.reducer;
